import React, { useState } from 'react';
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';
import withStyles from '../../../withStylesAdapter';
import {
  Card,
  CardContent,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Container,
  Grid,
  Divider
} from '@mui/material';

import ProfileMenu from '../ProfileMenu.js';
import { PlanSelect } from "../../../components/PricingPlans.js"
import SolutionsArticleLink from '../../../components/SolutionsArticleLink';
import DiscountCode from '../../../components/DiscountCode';

  
const styles = theme => ({
  root: {
    width: '100%',
    overflowX: 'auto',
  },
  table: {
    minWidth: 650,
  },
  label: {
      width: 200,
      background: '#fff',
      borderRight: 'solid 1px #ccc',
      position: 'sticky',
      left: 0,
      zIndex: 1
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    padding: 12
  }
});


const SubscriptionPage = ({ classes }) => {

  return (
    <React.Fragment>
      <Grid container spacing={3} alignItems="flex-start" className="page-content">
        <Grid size={12} className="page-content">
          <Typography variant="h4" component="h2">
            Subscription Plans

            {/* the heading is hardcoded English on every locale, so the subject is too */}
            <SolutionsArticleLink
              article="planFeatures"
              subject="Subscription Plans"
              placement="heading"
            />
          </Typography>
          <Divider className="divider-white" />
        </Grid>
        {/*<Grid size={12}>
          <Paper className={classes.paper}>
            Lorem ipsum dolor sed amit
          </Paper>
        </Grid>*/}
        <Grid size={12}>
          <PlanSelect />
        </Grid>
        <Grid size={12}>
          <DiscountCode />
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default withStyles(styles)(SubscriptionPage);
